export interface ShimmerBlock {
  value?: string | null
}

export function ShimmerBlock({ value }: ShimmerBlock) {
  return (
    <div className='ml-[40px]'>
      <div className='loading-shimmer'>{value}</div>
    </div>
  )
}
